import { useShopwareContext } from '@shopware/composables'
import type { Schemas } from '#shopware'
import { useState } from '#app'

export function useDictionary() {
    const { apiClient } = useShopwareContext()

    const dictionaryListing = useState<string[]>('dictionary:listing', () => [])
    const loading = useState<boolean>('dictionary:loading', () => false)
    const groupedLetters = useState<string[]>('dictionary:groupedLetters', () => [])
    const heroSection = useState<Schemas['CmsSection'] | undefined>('dictionary:heroSection', () => undefined)

    async function fetchCms(cmsId: string | null | undefined): Promise<Schemas['CmsPage'] | undefined> {
        if (!cmsId || cmsId.trim() === '') return undefined

        try {
            loading.value = true
            const { data } = await apiClient.invoke('readCms post /cms/{id}', {
                pathParams: { id: cmsId }
            })

            heroSection.value = data.sections?.find(
                (section: Schemas['CmsSection']) => section.blocks.some((block: Schemas['CmsBlock']) => block.type === 'hero-slider')
            )

            const dictionaryBlock = data.sections
                ?.flatMap((section: Schemas['CmsSection']) => section.blocks)
                .find((block: Schemas['CmsBlock']) => block.type === 'dictionary')

            const slotData = dictionaryBlock?.slots[0] as Schemas['CmsElementDictionary'] | undefined
            if (slotData?.data) {
                dictionaryListing.value = Object.values(slotData.data.listing ?? {})
                groupedLetters.value = Object.values(slotData.data.firstCharacter ?? {})
            }

            return data
        } catch (e) {
            console.error(e)
        } finally {
            loading.value = false
        }
    }

    return {
        dictionaryListing,
        loading,
        groupedLetters,
        heroSection,
        fetchCms,
    }
}
